@for (_ of [].constructor(numberOfRows); track $index) {
  <div class="skeleton-row">
    @for (__ of [].constructor(numberOfBlocs); track $index) {
      <div class="skeleton-bloc skeleton-shine"></div>
    }
  </div>
}
